import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-brand-beige last:border-0" data-id="element-325">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group pt-[24px] pb-[24px]" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-326">
        <span className="font-serif text-lg text-brand-dark group-hover:text-brand-violet transition-colors" data-id="element-327">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-brand-light transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-328" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-329">
        <p className="text-brand-light leading-relaxed pr-8" data-id="element-330">{answer}</p>
      </div>
    </div>;
}